import { t } from 'i18n-js';

type TOfferWallTranslation = (name: string) => string;
export const headlineOfferWallTranslation: TOfferWallTranslation = (name) =>
  t(`OfferWall_banner_${name}`);

export const subHeadlineOfferWallTranslation: TOfferWallTranslation = (name) =>
  t(`OfferWall_banner_${name}_subheadline`);
